import React, { useState, useEffect } from "react";
import { updateClientInfoState } from "../../utils/protobuf_utils";
import {
  AudioMessage_DevicePermissions_BrowserPermission_Status as MicPerm,
  AudioMessage_DevicePermissions_BrowserInteractionClickState_Status as MicClick,
} from "../../generated/audio_message";
import { MicrophoneImpl } from "../../utils/MicrophoneImpl";
import { useMicrophonePermissions } from "../MicrophonePermissions";
import MicrophonePermissioningView from "./MicrophonePermissioningView";
import LoadingUserComponent from "./LoadingUser";
import { useContentSize, saveContentSize } from "../../hooks/useContentSize";

interface Props {
  onMicrophonePermissioned: () => void;
  botName?: string;
};

type PermissionState =
  | "asking"
  | "waiting";

const MicrophonePermissioningContainer: React.FC<Props> = ({ onMicrophonePermissioned, botName }) => {
  const [{ isInitializing }, { checkMicrophonePermission, requestPermissionAndStart }] = useMicrophonePermissions();
  const [permissionModeOn, setPermissionModeOn] = useState<boolean>(false);
  const [micState, setMicState] = useState<PermissionState>("asking");
  const { ref: contentRef, size: contentSize } = useContentSize();

  // React to initialization state changes
  useEffect(() => {
    if (isInitializing) {
      setMicState("waiting");
    }
  }, [isInitializing]);

  const saveCardSize = () => {
    saveContentSize(contentRef);
  };

  const handleMicStart = async () => {
    saveCardSize();
    setMicState("waiting");
    const perm = await checkMicrophonePermission();
    if (perm === "granted") {
      await MicrophoneImpl.getInstance().start();
      updateClientInfoState({
        microphonePermission: MicPerm.AUTHORIZED,
        pixelStreamingInteraction: MicClick.CLICKED,
      });
      onMicrophonePermissioned();
    } else {
      setMicState("asking");
      setPermissionModeOn(true);

      const granted = await requestPermissionAndStart();

      updateClientInfoState({
        microphonePermission: granted ? MicPerm.AUTHORIZED : MicPerm.DENIED,
        pixelStreamingInteraction: MicClick.CLICKED,
      });

      if (granted) {
        onMicrophonePermissioned();
      } else {
        setMicState("asking");
        setPermissionModeOn(false);
      }
    }
    return;
  };

  if (micState === "asking") {
    return (
      <div ref={contentRef}>
        <MicrophonePermissioningView
          onAcceptAndContinue={handleMicStart}
          permissionMode={permissionModeOn}
          botName={botName}
        />
      </div>
    );
  }
  
  // micState === "waiting"
  return (
    <div
      style={{
        minHeight: contentSize?.height || "auto",
        minWidth: contentSize?.width || "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <LoadingUserComponent />
    </div>
  );
  // return <LoadingUserComponent />;
};

export default MicrophonePermissioningContainer;
